import React from 'react';

import { Button, Stack } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import { TEXT } from './constants';
import { validationSchema } from './schema';

export const CommentForm = withForm({
  validationSchema: validationSchema,
  enableReinitialize: true,
})(({
  submitForm,
  onCancel,
  setFieldValue,
  onLoadSuggestions,
  dirty,
  showAlwaysActions = false,
}) => {
  const { isAllowCommentMentions } = useGalleryPermissions();

  const handleSubmit = async () => {
    await submitForm();
  };

  const handleCancel = () => {
    setFieldValue(TEXT, undefined);
    onCancel?.();
  };

  return (
    <Stack spacing={2} direction={'column'}>
      <Stack>
        <FormField.MentionsRichText
          label={'Comment'}
          padding={0}
          name={TEXT}
          autofocus={true}
          loadMentions={isAllowCommentMentions ? onLoadSuggestions : undefined}
        />
      </Stack>
      {dirty || showAlwaysActions ? (
        <Stack spacing={2} direction={'row'} justifyContent={'flex-end'}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleSubmit} variant={'contained'}>
            Save
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
});
